export default function buildDrawerContextValue({
  mode,
  actions,
  integration,
  revisionMeta,
  pipelineData,
  pipelineSelection,
  chainState,
}) {
  const selectedPipeline =
    pipelineSelection.pipelines.find(pipeline => pipeline.id === pipelineSelection.selectedPipelineId) ?? null;

  return {
    mode,
    onChangeMode: actions.onChangeMode,
    onClusterChange: actions.onClusterChange,
    integrationName: integration.name,
    clusterName: pipelineData.clusterName,
    pipelineSelect: {
      options: pipelineSelection.options,
      loading: pipelineSelection.loading,
      selectedPipelineId: pipelineSelection.selectedPipelineId,
      onSelectPipeline: actions.onSelectPipeline,
    },
    pipelineContext: {
      ready: pipelineData.ready,
      attachment: pipelineData.attachment,
      pipelineVariables: revisionMeta.pipelineVariables,
      pipelineName: selectedPipeline?.name ?? null,
    },
    chainState,
  };
}
